const axios = require("axios");

export const getToken = () => {
  if (localStorage.getItem("keptLogged") == "true") {
    return localStorage.getItem("token") || null;
  }
  return sessionStorage.getItem("token") || null;
};

export const getAudienceAnalytics = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + "personal/audiences/analytics",
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const limitAudienceData = async (limit, offSet, searchText) => {
  const response = await axios.get(
    searchText
      ? process.env.REACT_APP_API_BASE_URL +
          `personal/audiences?limit=${limit}&offset=${offSet}&search=${searchText}`
      : process.env.REACT_APP_API_BASE_URL +
          `personal/audiences?limit=${limit}&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getOverAllCount = async (searchText) => {
  const response = await axios.get(
    searchText
      ? process.env.REACT_APP_API_BASE_URL +
          `personal/audiences/count?search=${searchText}`
      : process.env.REACT_APP_API_BASE_URL + `personal/overall/count`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAudiences = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + "personal/audiences",
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAudiencesById = async (id, limit, offSet) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
      `personal/audiences/${id}?limit=${limit}&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getFullAudience = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `personal/audiences/filters/${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};



export const getAudiencesByIdCount = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `personal/audiences/${id}/count`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getNewAudienceFilter = async () => {
  return axios.get(
    process.env.REACT_APP_API_BASE_URL + "personal/filters/new",
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
};

export const getCustomApiCall = async (url) => {
  return axios.get(process.env.REACT_APP_API_BASE_URL + `${url}`, {
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
};

export const postPreviewAudienceData = async (data) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + "personal/filters/persons",
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const postSaveAudienceData = async (data) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + "personal/audiences",
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const putSaveAudienceData = async (data,id) => {
  const response = await axios({
    method: "put",
    url: process.env.REACT_APP_API_BASE_URL + "personal/audiences/"+id,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const postFiltersPersonsCount = async (data) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + "personal/filters/persons/count",
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const postFiltersPersons = async (data, offSet, limit) => {
  const response = await axios({
    method: "post",
    url:
      process.env.REACT_APP_API_BASE_URL +
      `personal/filters/persons?limit=${limit}&offset=${offSet}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};



